export const money = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(value || 0);

export const formatDate = (value, long = false) =>
  new Intl.DateTimeFormat('en-US', {
    weekday: long ? 'long' : undefined,
    month: 'long',
    day: 'numeric',
    year: long ? 'numeric' : undefined
  }).format(new Date(`${value}T12:00:00`));

export const formatTime = (value) => {
  if (!value) return '';
  const [hours, minutes] = value.split(':');
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit'
  }).format(new Date(2026, 0, 1, Number(hours), Number(minutes)));
};

export const confirmedSeats = (sessionId, reservations) =>
  reservations
    .filter((item) => item.trip_session_id === sessionId && item.status === 'CONFIRMED')
    .reduce((sum, item) => sum + Number(item.party_size), 0);

export const adjustmentTotal = (sessionId, adjustments) =>
  adjustments
    .filter((item) => item.trip_session_id === sessionId)
    .reduce((sum, item) => sum + Number(item.quantity), 0);

export const rawAvailability = (session, reservations, adjustments) =>
  Number(session.capacity)
  - confirmedSeats(session.id, reservations)
  + adjustmentTotal(session.id, adjustments);

export const availableSeats = (session, reservations, adjustments) =>
  Math.max(0, Math.min(Number(session.capacity), rawAvailability(
    session,
    reservations,
    adjustments
  )));

export const displayStatus = (session, reservations, adjustments) => {
  if (session.status !== 'OPEN' && session.status !== 'FULL') return session.status;
  return availableSeats(session, reservations, adjustments) === 0 ? 'FULL' : 'OPEN';
};